module.exports = __webpack_public_path__ + "static/media/architecture-draft.09971fa2.jpg";